import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

const Seg = ({ value, options, onChange, busy, testid }) => (
  <div className="inline-flex rounded-full border border-white/15 p-0.5 bg-black/40" data-testid={testid}>
    {options.map(([v, label]) => (
      <button key={v} type="button" disabled={busy} onClick={() => onChange(v)} data-testid={`${testid}-${v}`}
        className={`px-3 h-7 rounded-full text-xs font-semibold transition-colors ${value === v ? "bg-white text-black" : "text-neutral-400 hover:text-white"}`}>
        {label}
      </button>
    ))}
  </div>
);

export function GatewayOptions() {
  const [cfg, setCfg] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/payments/config").then(({ data }) => setCfg(data)).catch(() => {}); }, []);

  const save = async (body, msg) => {
    setBusy(true);
    try { const { data } = await api.post("/payments/gateway-options", body); setCfg(data); toast.success(msg); }
    catch (ex) { toast.error(formatApiError(ex.response?.data?.detail) || "Could not save"); }
    finally { setBusy(false); }
  };

  if (!cfg) return null;
  return (
    <div className="mt-4 rounded-lg border border-[#27272A] bg-[#0A0A0A] p-4 space-y-4" data-testid="gateway-options">
      <div className="text-xs uppercase tracking-widest text-neutral-500">Buyer payment routing</div>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <div className="font-bold text-sm">Flutterwave charges in</div>
          <div className="text-xs text-neutral-500 mt-0.5" data-testid="flw-currency-help">
            {cfg.flutterwave_currency === "USD"
              ? "International buyers pay exact USD; settles to your domiciliary account. Nigerian buyers are steered to Paystack in ₦."
              : "Naira at the checkout rate. Switch to USD once Flutterwave approves USD collections + your domiciliary settlement account."}
          </div>
        </div>
        <Seg testid="flw-currency" busy={busy} value={cfg.flutterwave_currency}
          options={[["NGN", "₦ Naira"], ["USD", "$ US Dollar"]]}
          onChange={(v) => save({ flutterwave_currency: v }, v === "USD" ? "Flutterwave now charges USD (international buyers)" : "Flutterwave now charges Naira")} />
      </div>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <div className="font-bold text-sm">Show Stripe to buyers</div>
          <div className="text-xs text-neutral-500 mt-0.5" data-testid="stripe-setting-help">
            Key is <span className="font-mono">{cfg.stripe_mode}</span> · currently <span className={cfg.stripe_enabled ? "text-[#34C759]" : "text-[#FF9F0A]"}>{cfg.stripe_enabled ? "visible" : "hidden"}</span>. Auto hides it until a live Stripe key is set.
          </div>
        </div>
        <Seg testid="stripe-setting" busy={busy} value={cfg.stripe_setting}
          options={[["auto", "Auto"], ["on", "On"], ["off", "Off"]]}
          onChange={(v) => save({ stripe_setting: v }, `Stripe for buyers: ${v}`)} />
      </div>
    </div>
  );
}
